import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const adminAuth = localStorage.getItem('adminAuth');
    if (token && adminAuth === 'true') {
      // Verify token is still valid by checking expiry
      try {
        const tokenParts = token.split('.');
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));
          const currentTime = Date.now() / 1000;
          if (payload.exp && payload.exp > currentTime) {
            // Token is valid, restore session
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            setAdmin({ token });
          } else {
            // Token expired, clear auth
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminAuth');
          }
        }
      } catch (error) {
        // Invalid token, clear auth
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminAuth');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'https://bereliable-474393705172.europe-west1.run.app/api'}/auth/login`, {
        username,
        password
      });

      if (response.data.success) {
        const { token, admin: adminData } = response.data;
        localStorage.setItem('adminToken', token);
        localStorage.setItem('adminAuth', 'true');
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        setAdmin({ ...adminData, token });
        return { success: true };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminAuth');
    delete axios.defaults.headers.common['Authorization'];
    setAdmin(null);
  };

  const value = {
    admin,
    login,
    logout,
    loading,
    isAuthenticated: !!admin
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};


